<template>

  <div class="card flex-1 md:rounded" :style="gradient">
    <div :style="backImage" class="w-full h-full md:rounded">
      <v-layout row wrap style="max-width: 1200px;margin: auto;">
        <v-flex xs6 offset-xs3 sm3 offset-sm0 class="logo text-center">
          <img class="image-center" :src="tag.icon" />
        </v-flex>
        <template v-if="tag.type !== 'streaming'">
          <v-flex xs12 sm9>
            <Carousel
              :perPageCustom="[[0, 1], [500, 2], [600, 3], [900, 3], [1100, 3], [1500, 3]]"
              :paginationEnabled="false"
              :navigationEnabled="true"
              :minSwipeDistance="1"
              navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
              navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
              :touchDrag="true"
              :mouseDrag="true"
              :resistanceCoef="0">
              <Slide v-for="item in tag.programs" :key="item.id"
                @slideclick="slideclick(item)"
                @mouseup="transitionstart"
                @mousedown="transitionend">
                <ProgramSlide :item="item" :key="item.id" :events="false"></ProgramSlide>
              </Slide>
            </Carousel>
          </v-flex>
        </template>
        <template v-else>
          <v-flex xs12 sm9>
            <Carousel
              :perPageCustom="[[0, 1], [500, 1.5], [600, 1.5], [900, 1.5], [1100, 1.5], [1500, 1.5]]"
              :paginationEnabled="false"
              :navigationEnabled="true"
              :minSwipeDistance="1"
              navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
              navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
              :touchDrag="true"
              :mouseDrag="true"
              :resistanceCoef="0">
              <Slide v-for="item in tag.programs" :key="item.id"
                @slideclick="slideclick(item)"
                @mouseup="transitionstart"
                @mousedown="transitionend">
                <ProgramSlide :item="item" :key="item.id" :events="false" :horizontal="true"></ProgramSlide>
              </Slide>
            </Carousel>
          </v-flex>
        </template>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import ProgramSlide from './ProgramSlide'
export default {
  components: { Carousel, Slide, ProgramSlide },
  data: () => ({
    t: Date.now()
  }),
  props: {
    tag: Object
  },
  computed: {
    gradient () {
      const topColor = this.tag.color_top
      const bottomColor = this.tag.color_bottom ? this.tag.color_bottom : topColor
      return {
        background: "linear-gradient("+topColor+", "+bottomColor+")"
      }
    },
    backImage () {
      return {
        'background-image': "url('"+this.tag.background_image_big+"')",
        'box-shadow': "1px 1px #00000052",
        'background-size': "100%",
        'object-fit': 'cover'
      }
    }
  },
  methods: {
    slideclick (item) {
      this.$router.push({ name: 'Program', params: { slug: item.slug } })
    },
    transitionstart () {
      this.t = Date.now()
      console.time(this.t)
      alert(this.t)
    },
    transitionend () {
      console.time('end:', Date.now() - this.t)
      alert((Date.now() - this.t).toString())
    }
  }
}
</script>
<style scoped>
  .tag-title{
    font-family: Montserrat;
    font-size: 30px !important;
    color: black;
    line-height: 1em;
    font-size: small;
    text-indent: 10px;
    padding-top: 1.5em;
    padding-bottom: 10px;
  }
  .layout-custom {
    /*background: url(../assets/mancha_negra_2.png);*/
    /*background: url(../assets/mancha_negra_top.png);*/
    background-size: 100%;
    background-position-y: 10%;
    padding-top: 3%;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 480px) {
    .layout-custom {
      /*background: url(../assets/mancha_negra_top.png);*/
      background-size: 100%;
      background-position-y: 10%;
      padding-top: 3%;
      background-repeat: no-repeat;
    }
  }
  @media screen and (max-width: 768px) {
    .tag-title {
      line-height: 3em;
      padding-top: 0;
      text-align: center;
    }
  }

</style>
<style>
  /*@media only screen and (max-width: 500px) {*/
    .layout-custom .VueCarousel-inner {
      width: 80% !important;
    }
  /*}*/
  .layout-custom .VueCarousel-inner {
    overflow: visible !important;
    padding-left: 10px;
  }

  .VueCarousel-navigation-next,
  .VueCarousel-navigation-prev {
    padding: 0 !important;
    margin: 0 !important;
    right: 30px !important;
    font-size: 20px;
    background: white !important;
    border-radius: 100%;
    width: 30px;

    height: 30px;
    font-family: Material Icons;
  }
  .VueCarousel-navigation-button .material-icons {
    font-weight: bolder;
    margin-top: 3px;
  }
  .VueCarousel-navigation-prev {
    left: 30px !important;
  }
  .VueCarousel-inner {
    min-height: 300px;
  }
  .text-center {
    align-items: center;
    display: flex;
    margin-top: 0%;
  }
  .image-center {
    object-fit: contain;
    padding: 10%;
    max-width: 100%;
  }
</style>
